import { CardCarousel, Skeleton, SkeletonItem } from '@capsicum/common-web';
import styled, { useTheme } from 'styled-components';

type AuctionSkeletonProps = {
	repeats?: number;
};

export const SkeletonAuctions = ({ repeats = 3 }: AuctionSkeletonProps) => {
	const { border, colors, sizing } = useTheme();

	const radius = parseInt(border.radius.large['border-radius']);
	const radiusSmall = parseInt(border.radius.small['border-radius']);

	return (
		<S.Layout>
			{[...new Array(repeats)].map((value, index) => (
				<div key={index}>
					<S.TitleWrapper>
						<div>
							<Skeleton baseColor={colors.skeleton.default} highlightColor={colors.skeleton.highlight}>
								<SkeletonItem height={parseInt(sizing.medium)} width={140} />
								<SkeletonItem borderRadius={radiusSmall} height={parseInt(sizing.medium)} width={80} />
							</Skeleton>
						</div>
						<div>
							<Skeleton baseColor={colors.skeleton.default} highlightColor={colors.skeleton.highlight}>
								<SkeletonItem height={parseInt(sizing.medium)} width={70} />
							</Skeleton>
						</div>
					</S.TitleWrapper>
					<S.CarrouselWrapper
						arrowsVisible
						cardWidth={173}
						testID="fanshop-category-carousel-skeleton"
						variant="fullWidth"
					>
						{[...new Array(5)].map((value, index) => (
							<S.CardWrapper key={index}>
								<Skeleton
									baseColor={colors.skeleton.default}
									highlightColor={colors.skeleton.highlight}
								>
									<S.ImageSkeleton height={186} />
								</Skeleton>
								<S.DetailContainer>
									<Skeleton
										baseColor={colors.skeleton.default}
										highlightColor={colors.skeleton.highlight}
									>
										<SkeletonItem borderRadius={radius} height={20} width={141} />
									</Skeleton>
									<Skeleton
										baseColor={colors.skeleton.default}
										highlightColor={colors.skeleton.highlight}
									>
										<SkeletonItem borderRadius={radiusSmall} height={20} width={48} />
									</Skeleton>
									<Skeleton
										baseColor={colors.skeleton.default}
										highlightColor={colors.skeleton.highlight}
									>
										<SkeletonItem borderRadius={radiusSmall} height={69} width={141} />
									</Skeleton>
								</S.DetailContainer>
							</S.CardWrapper>
						))}
					</S.CarrouselWrapper>
				</div>
			))}
		</S.Layout>
	);
};

namespace S {
	export const Layout = styled.div`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xlarge};
	`;

	export const TitleWrapper = styled.div`
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	`;

	export const CarrouselWrapper = styled(CardCarousel)`
		margin-top: ${({ theme }) => theme.spacings.xsmall};
	`;

	export const CardWrapper = styled.div`
		background: ${({ theme }) => theme.colors.backgrounds.main.container};
		${({ theme }) => theme.border.radius.medium};
	`;

	export const ImageSkeleton = styled(SkeletonItem)`
		${({ theme }) => theme.border.radius.mediumTop};
	`;

	export const DetailContainer = styled.div`
		display: flex;
		flex-direction: column;
		padding: ${({ theme }) => theme.spacings.small};
		gap: ${({ theme }) => theme.spacings.xxsmall};
	`;
}
